import { cn } from '@/common/lib/cn/cn'

interface PaginationProps {
    currentPage: number
    totalPages: number
    onPageChange: (page: number) => void
    className?: string
}

export const Pagination = ({ currentPage, totalPages, onPageChange, className }: PaginationProps) => {
    const getPageNumbers = () => {
        const pages = []
        const maxVisiblePages = 5
        const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2))
        const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1)

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i)
        }

        return pages
    }

    const pageNumbers = getPageNumbers()

    if (totalPages <= 1) {
        return null
    }

    return (
        <div className={cn('join', className)}>
            {/* Кнопка "Предыдущая" */}
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className='join-item btn'
            >
                ←
            </button>

            {/* Первая страница */}
            {pageNumbers[0] > 1 && (
                <>
                    <button onClick={() => onPageChange(1)} className='join-item btn'>
                        1
                    </button>
                    {pageNumbers[0] > 2 && <span className='px-2'>...</span>}
                </>
            )}

            {/* Номера страниц */}
            {pageNumbers.map(page => (
                <button
                    key={page}
                    onClick={() => onPageChange(page)}
                    className={cn('join-item btn', {
                        'btn-active': page === currentPage,
                    })}
                >
                    {page}
                </button>
            ))}

            {/* Последняя страница */}
            {pageNumbers[pageNumbers.length - 1] < totalPages && (
                <>
                    {pageNumbers[pageNumbers.length - 1] < totalPages - 1 && <span className='px-2'>...</span>}
                    <button onClick={() => onPageChange(totalPages)} className='join-item btn'>
                        {totalPages}
                    </button>
                </>
            )}

            {/* Кнопка "Следующая" */}
            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className='join-item btn'
            >
                →
            </button>
        </div>
    )
}
